import { render, staticRenderFns } from "./MainGeneralForm.vue?vue&type=template&id=943d4f1e&"
import script from "./MainGeneralForm.vue?vue&type=script&lang=js&"
export * from "./MainGeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./MainGeneralForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports